
import profile from '@/utils/profile'
import { jsFn } from '@/utils/jsFn'
import { post } from '@/api/http'

var accept = 'application/vnd.sokradeo.v1+json'
let hostname = window.location.hostname
var serverLocation = jsFn.isCN() ? 'cn' : 'global'

if(hostname.indexOf('localhost') === 0) {
    serverLocation = 'global'
}

var apiUrl = profile.sokmgrApi[serverLocation]

export default {
    // 加入頻道
    applyChannel: function(tokens, schoolCode){
        return new Promise((resolve, reject) => {
            let headers = {
                headers:{
                    'Content-type': 'application/json ;charset=utf8',
                    'application': 'a958df06-dd89-4e7b-b929-d35f9a6d6818',
                    'Authorization': `${tokens.token_type} ${tokens.id_token}`,
                    'Accept': accept
                }
            }
            let data = {
                "school_shortcode": schoolCode
            }

            post(apiUrl + '/api/school/apply-join-channel', data, headers).then(() => {
                resolve(true)
            }, err => {
                reject(err)
            })
        })
    },
}
